/* eslint-disable no-unreachable */
import indexArray from 'index-array';
import deepMerge from 'deepmerge';
import { Duck } from '@atc/modular-redux';
import selectors from './ownersDuckSelectors';
const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;
const mergeOptions = {
  arrayMerge: overwriteMerge
};
export default function ownersDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'owners',
    storePath,
    initialState = {},
    ...rest
  } = _temp === void 0 ? {} : _temp;
  return new Duck({
    ...rest,
    namespace,
    store,
    storePath,
    consts: {},
    types: ['ADD_OWNERS', 'SET_OWNERS', 'UPDATE_OWNER'],
    initialState,
    reducer: (state, action, _ref) => {
      let {
        types
      } = _ref;
      switch (action.type) {
        case types.ADD_OWNERS:
          {
            return deepMerge(state, action.payload, mergeOptions);
            break;
          }
        case types.SET_OWNERS:
          {
            return action.payload;
          }
        case types.UPDATE_OWNER:
          {
            const {
              id,
              data = {}
            } = action.payload;
            return {
              ...state,
              [id]: deepMerge(state[id], data, mergeOptions)
            };
            break;
          }
        default:
          return state;
      }
    },
    creators: _ref2 => {
      let {
        types
      } = _ref2;
      return {
        addOwners: data => {
          let owners = data;

          // If owners is passed as an array index it by id for lookup
          if (Array.isArray(data)) {
            owners = indexArray(data, 'id');
          }
          return {
            type: types.ADD_OWNERS,
            payload: owners
          };
        },
        setOwners: data => {
          let owners = data;

          // If owners is passed as an array index it by id for lookup
          if (Array.isArray(data)) {
            owners = indexArray(data, 'id');
          }
          return {
            type: types.SET_OWNERS,
            payload: owners
          };
        },
        updateOwner: (id, data) => ({
          type: types.UPDATE_OWNER,
          payload: {
            id,
            data
          }
        })
      };
    },
    selectors
  });
}